import { isEmpty } from 'lodash'
import { dropdownHeaderOptions } from '../../constants'
import MenuHeaderSearch from './menu-header-search'
import MenuHeaderSection from './menu-header-section'
import MenuHeaderTabs from './menu-header-tabs'
import MenuHeaderDefault from './menu-header-default'

const MenuHeader = ({ menuHeader, options, selectedTab, handleSelectTab }) => {
  if (isEmpty(menuHeader)) return <MenuHeaderDefault options={options} />

  if (menuHeader.type === dropdownHeaderOptions.SEARCH) { return <MenuHeaderSearch options={options} /> }

  if (menuHeader.type === dropdownHeaderOptions.SECTION) { return <MenuHeaderSection title={menuHeader.title} options={options} /> }

  if (menuHeader.type === dropdownHeaderOptions.TABS) {
    return (
      <MenuHeaderTabs
        tabOptions={menuHeader.tabOptions}
        selectedTab={selectedTab}
        selectedName={selectedTab.name}
        handleSelectTab={handleSelectTab}
      />
    )
  }

  return null
}

export default MenuHeader
